import { defineStore } from 'pinia';
import { store } from '/@/store';
//import { ProductItemType } from '/@/api/exchangeService/model/product';
import { createLocalStorage } from '/@/utils/cache';
import { DMP_DRO_INFO_KEY } from '/@/enums/cacheEnum';
import { buildUUID } from '/@/utils/uuid';
import { useRouter } from 'vue-router';
import { dmpDroInfoApi } from '/@/api/dmp';
import { HoldingListItem } from '/@/api/exchangeService/model/holding';
import { DroDetailType } from '/@/api/dmp/model/dro';

export enum OperationType {
  // 查看详情
  viewDetail = 'viewDetail',
  // 持仓中
  holding = 'holding',
  // 挂牌转让
  listingTransfer = 'listingTransfer',
  // 申请回售
  applyResale = 'applyResale',
}

const ls = createLocalStorage();

interface BuyingState {
  operateType: Nullable<OperationType>;
  uuid: string;
  droDetail: Nullable<DroDetailType>;
  holdingInfo: Nullable<HoldingListItem>;
}
/**
 * DMP DRO详情
 */
export const useDmpDroStore = defineStore({
  id: 'dmp-dro',
  state: (): BuyingState => ({
    operateType: null,
    uuid: buildUUID(),
    droDetail: null,
    holdingInfo: null,
  }),
  getters: {
    getOperateType(): OperationType {
      // operateType不存在则从缓存中获取
      if (!this.operateType) {
        const operateType = ls.get(`${DMP_DRO_INFO_KEY}-operateType`) || OperationType.viewDetail;
        this.operateType = operateType;
      }
      return this.operateType as OperationType;
    },

    /**
     *
     * @returns 持仓信息
     */
    getHoldingInfo(): Nullable<HoldingListItem> {
      //holdingInfo不存在则从缓存中获取
      if (!this.holdingInfo) {
        const holdingInfo = ls.get(`${DMP_DRO_INFO_KEY}-holdingInfo`);
        this.holdingInfo = holdingInfo;
      }
      return this.holdingInfo;
    },
  },
  actions: {
    // 重置uuid
    resetUuid() {
      this.uuid = buildUUID();
    },

    /**
     * 设置操作类型
     */
    setOperateType(type: OperationType) {
      this.operateType = type;
      // 保存在本地
      ls.set(`${DMP_DRO_INFO_KEY}-operateType`, type);
    },

    /**
     * 设置DRO详情
     * @param droDetail {DroDetailType} etp详情
     */
    setDroInfo(droDetail: DroDetailType) {
      this.droDetail = droDetail;
    },

    async fetchDroData(droCode: string | null = null) {
      if (!droCode) {
        const router = useRouter();
        const { currentRoute } = router;
        droCode = currentRoute.value.params.productCode as string;
      }

      const res = await dmpDroInfoApi({ droCode });
      this.setDroInfo(res);
    },
  },
});

// Need to be used outside the setup
export function useDmpDroStoreWithOut() {
  return useDmpDroStore(store);
}
